import { Crafting__factory, Map__factory } from 'public/abi/evm/types';
import useEnvs from '~/composables/useEnvs';
import useProvider from '~/composables/useProvider';
import type { BuildingProps, RecipeProps } from '~/types/crafting';

export default async (
  recipeToCraft: Ref<RecipeProps | null, RecipeProps | null>,
  building: Ref<BuildingProps> | undefined
) => {
  const { getProvider } = useProvider();
  const { blockchain } = useEnvs();

  const maxQueuePerUser = ref(0);
  const isLoading = ref(false);

  watch(
    [() => recipeToCraft.value?.recipeId, () => building?.value.buildingHash],
    async () => {
      try {
        isLoading.value = true;

        const craftingContract = Crafting__factory.connect(blockchain.contracts.crafting, getProvider());
        const mapContract = Map__factory.connect(blockchain.contracts.map, getProvider());

        const { buildingNameHash } = await mapContract.getLandBuilding(building?.value.buildingHash || '');

        const { maxQueuePerUser: maxQueuePerUserValue } = await craftingContract.getMaxQueueForRecipeInBuilding(
          buildingNameHash,
          recipeToCraft.value?.recipeId || ''
        );

        maxQueuePerUser.value = Number(maxQueuePerUserValue);
      } catch (error) {
        console.error(error, 'error on getting max queue per user');
      } finally {
        isLoading.value = false;
      }
    },
    {
      immediate: true
    }
  );

  return {
    maxQueuePerUser,
    isLoading
  };
};
